import React from 'react';
import PropTypes from 'prop-types';

export default function Schema({ value }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
        __html: JSON.stringify(value),
      }}
    />
  );
}

// TODO expand upon this
Schema.propTypes = {
  value: PropTypes.shape().isRequired,
};
